import { useFormaliteService } from '@europrocurement/l2d-domain';
import {
    INIT_ITEMS_CTX,
    useDossierValidatorCtxDispatch,
    useDossierValidatorsCtx,
} from '../providers/DossierValidatorsProvider';

const useLazyDataLoader = () => {
    const { isDataLoaded: validatorsDataLoaded } = useDossierValidatorsCtx();
    const dispatch = useDossierValidatorCtxDispatch();
    const { validatorsApi } = useFormaliteService();

    const loadValidators = async (): Promise<void> => {
        if (validatorsDataLoaded() || !dispatch) {
            return Promise.resolve();
        }

        const response = await validatorsApi.apiDossiersValideursGetCollection({
            itemsPerPage: 999,
        });
        dispatch({
            type: INIT_ITEMS_CTX,
            payload: response.data['hydra:member'],
        });

        return Promise.resolve();
    };

    return { loadValidators };
};

export default useLazyDataLoader;
